const USERTYPES = {
  'super_admin': 'super_admin',
  'client_admin': 'Client admin',
  'client_mgr': 'client_mgr',
}

export default USERTYPES;
